import { useLocation } from "react-router-dom";

import usePageTitle from "@/hooks/usePageTitle";
import { DOMAIN, PERMISSION, useRequireCapability } from "@/hooks/useCapabilities";

import CreateFacilityForm from "../_components/CreateFacilityForm";
import { type CreateFacilityFormInitialValues } from "../_utils/createFacilityForm";

type CreateFacilityLocationState = {
  initialValues?: CreateFacilityFormInitialValues;
};

export default function CreateFacilityPage() {
  useRequireCapability({ domain: DOMAIN.FACILITIES, permission: PERMISSION.createFacilities });
  usePageTitle("/facilities/new", "Facilities | Create Facility");

  const location = useLocation();
  const initialValues = (location.state as CreateFacilityLocationState | null)?.initialValues;

  return (
    <div data-testid="create-facility-page">
      <CreateFacilityForm initialValues={initialValues} />
    </div>
  );
}
